<template lang="pug">
    d2-container
            el-form(:inline='true', :model='dataForm', size='mini',label-position='left', label-width='75px' @keyup.enter.native='getDataList()')
              el-row
                el-col(:span='7')
                  el-form-item(label="用户名:")
                      el-input.inputWidth(v-model='dataForm.username', placeholder='用户名', clearable='')
                el-col(:span='7')      
                  el-form-item(label="主办方:")
                    el-select.inputWidth(v-model="dataForm.orgId" placeholder="请选择" filterable clearable)
                      el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
                el-col(:span='7')        
                  el-form-item(label="操作时间:")
                    el-date-picker(style='width:210px;'   v-model='operateTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable='' )
                //-   el-form-item(label="操作时间:")
                //-       el-date-picker(v-model="dataForm.startTime"  type="datetime" placeholder="选择日期时间" ,style='width:175px;')
                //- el-col(:span='5')       
                //-   el-form-item(label="至:" label-width='30px')
                //-       el-date-picker(v-model="dataForm.endTime"  type="datetime" placeholder="选择日期时间",style='width:175px;') 
                el-col(:span='24' style='padding-bottom:15px;')      
                      el-button(@click='getDataList()' ,type='primary',icon='el-icon-search' style="float:right;") 查询
            el-table(:data='dataList', border='', v-loading='dataListLoading', @selection-change='selectionChangeHandle', style='width: 100%;')
                el-table-column(prop='username', header-align='center', align='center', label='用户名')
                el-table-column(prop='orgName', header-align='center', align='center', label='主办方')
                el-table-column(prop='createDate', header-align='center', align='center', label='操作时间')
                el-table-column(prop='operation', header-align='center', align='center', label='操作纪录')
            el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        username : '',
        orgId : '',
        startTime : '',
        endTime : ''
      },
      operateTime:'',
      sysOrgList: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false
    }
  },
  created () {
    this.getDataList()
    this.initOrg()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      if (this.operateTime !== null && this.operateTime.length > 0) {
          this.dataForm.startTime = this.operateTime[0];
          this.dataForm.endTime = this.operateTime[1];
      }else{
          this.dataForm.startTime = '';
          this.dataForm.endTime = '';
      }
      this.$http({
        url: this.$http.adornUrl('/sys/log/list'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'username': this.dataForm.username,
          'orgId': this.dataForm.orgId,
          'startTime' : this.dataForm.startTime,
          'endTime' : this.dataForm.endTime
        })
      }).then((data) => {
        console.log('data', data)
        if (data && data.code === 0) {
          this.dataList = data.page.records
          this.totalPage = data.page.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    initOrg () {
        this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    }
  }
}
</script>
<style>
  .inputWidth{
  width: 210px;
}
</style>